import { Flex } from "antd"
import React from "react"

export function FixedContainer({ children }: React.PropsWithChildren) {
  return (
    <div className={"grid size-full min-h-0"}>
      <Flex
        vertical
        gap={"small"}
        data-testid={"fixed-container"}
        // The support widget is pinned 88px up from the bottom-right corner, so
        // the column reserves that much below its last card — otherwise the
        // bottom-most row of actions cannot be scrolled out from under it.
        //
        // That reserve is padding, and a sticky child's travel stops at the
        // content edge above it, so anything sticking to the bottom halts 96px
        // short of the visible one. `--floating-action-inset` publishes the
        // reserve so such a child can subtract it back; `TableAddAction` does.
        className={
          "min-h-0 max-h-[calc(100vh-88px)] overflow-auto p-1 -m-1 pb-24 [--floating-action-inset:6rem]"
        }
      >
        {children}
      </Flex>
    </div>
  )
}
